<statistics-has-sample-msg></statistics-has-sample-msg>
<page-header icon="fas fa-language" header="{{'Languages' | translate}}" [subHeader]="'View data for the selected period.' | translate" [panelClass]="(domain | isStatsSampleData) ? 'mt-1' : ''">
    <page-header-content>
        <div class="row">
            <div class="col-48 d-flex align-items-center justify-content-end">
                <csv-export-button
                    [monDisabled]="domain | isStatsSampleData"
                    [exports]="exports">
                </csv-export-button>
                <date-picker [monEnableComparisonRange]="false"
                                     [(date)]="date"
                                     [monDateFormat]="'ddd, D. MMM YYYY'"
                                     (dateChange)="updateDateRange()">
                </date-picker>
            </div>
        </div>
    </page-header-content>
</page-header>
<div class="card panel-monsido-card statistics-visitors-language">
    <div class="card-body">
        <div *ngIf="loading" class="table-spinner text-center">
            <span class="fas fa-spinner fa-spin fa-3x fa-fw" aria-hidden="true"></span>
        </div>
        <div class="row" *ngIf="pages.length === 0 && !loading">
            <div class="col-48">
                <h3 class="font-weight-300 text-grey text-center table-spinner" translate>No data available</h3>
            </div>
        </div>
        <div *ngIf="!loading && pages.length > 0">
            <div class="row mb-6">
                <div class="col-48 chart-center">
                    <mon-chart-pie
                            [labels]="doughnutLabels"
                            [data]="doughnutData"
                            [options]="doughnutOptions"
                            *ngIf="chartType === 'chart'">
                    </mon-chart-pie>
                </div>
            </div>
            <table class="table table-hover">
                <thead>
                <tr>
                    <th class="col-sm-3 col-md-3" translate>Name</th>
                    <th class="col-sm-3 col-md-3 text-center">
                        <span translate>Visits</span>
                    </th>
                    <th class="col-sm-2 col-md-2 text-center">
                        <span translate>Bounce rate</span>
                    </th>
                    <th class="col-sm-2 col-md-2 text-right">
                        <span translate>Actions per visit</span>
                    </th>
                    <th class="col-sm-2 col-md-2 text-right">
                        <span translate>Average time</span>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let page of pages">
                    <td class="text-v-middle">{{page.label}}</td>
                    <td class="text-v-middle"><statistics-visits [visits]="page.visits" [totalVisits]="totalVisits"></statistics-visits></td>
                    <td class="text-v-middle text-center">{{page.bounce_rate / page.visits | monNumber:'0.[00]%'}}</td>
                    <td class="text-v-middle text-right">{{page.actions / page.visits | monNumber:'0.[00]'}}</td>
                    <td class="text-v-middle text-right">{{page.avg_time / page.visits | monNumber:'00:00:00'}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>